import React from "react";

type Props = {
    height: number;
    width: number;
};

export const AcxNewIcon = ({ height, width }: Props) => (
    <svg
        width="218"
        height="120"
        viewBox="0 0 218 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_20401_1342)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.34497 98.1983C4.34497 108.153 12.4321 116.23 22.4165 116.23C32.401 116.23 40.4881 108.153 40.4881 98.1983V70.9803C40.4881 61.0255 32.401 52.9488 22.4165 52.9488C12.4321 52.9488 4.34497 61.0255 4.34497 70.9803L4.34497 98.1983ZM22.4165 120.23C10.2305 120.23 0.344971 110.37 0.344971 98.1983L0.344971 70.9803C0.344971 58.8088 10.2305 48.9488 22.4165 48.9488C34.6026 48.9488 44.4881 58.8088 44.4881 70.9803V98.1983C44.4881 110.37 34.6026 120.23 22.4165 120.23Z"
                fill="#6F95F4"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M53.4758 98.1983C53.4758 108.153 61.563 116.23 71.5474 116.23C81.5318 116.23 89.619 108.153 89.619 98.1983V70.9803C89.619 61.0255 81.5318 52.9488 71.5474 52.9488C61.563 52.9488 53.4758 61.0255 53.4758 70.9803V98.1983ZM71.5474 120.23C59.3614 120.23 49.4758 110.37 49.4758 98.1983V70.9803C49.4758 58.8088 59.3614 48.9488 71.5474 48.9488C83.7334 48.9488 93.619 58.8088 93.619 70.9803V98.1983C93.619 110.37 83.7334 120.23 71.5474 120.23Z"
                fill="#C0F2E9"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M182.88 106.96C189.938 114.003 201.38 114.003 208.436 106.962C215.493 99.9207 215.492 88.5034 208.434 81.4606L189.147 62.2146C182.089 55.1718 170.647 55.1713 163.591 62.2125C156.534 69.2537 156.535 80.671 163.593 87.7138L182.88 106.96ZM211.268 109.787C202.647 118.389 188.67 118.388 180.049 109.785L160.761 90.5392C152.14 81.9364 152.139 67.9891 160.759 59.3871C169.38 50.7851 183.357 50.7864 191.978 59.3892L211.266 78.6352C219.887 87.238 219.888 101.185 211.268 109.787Z"
                fill="#FF835E"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M106.976 98.1983C106.976 108.153 115.063 116.23 125.048 116.23C135.032 116.23 143.119 108.153 143.119 98.1983V21.8014C143.119 11.8466 135.032 3.76992 125.048 3.76992C115.063 3.76992 106.976 11.8466 106.976 21.8014V98.1983ZM125.048 120.23C112.862 120.23 102.976 110.37 102.976 98.1983V21.8014C102.976 9.62997 112.862 -0.23008 125.048 -0.23008C137.234 -0.23008 147.119 9.62997 147.119 21.8014V98.1983C147.119 110.37 137.234 120.23 125.048 120.23Z"
                fill="#FFDE72"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.1547 3.83496C11.38 3.83496 4.27393 10.9319 4.27393 19.6774V24.0495C4.27393 32.795 11.38 39.892 20.1547 39.892H77.0197C85.7945 39.892 92.9006 32.795 92.9006 24.0495V19.6774C92.9006 10.9319 85.7945 3.83496 77.0197 3.83496H20.1547ZM0.273926 19.6774C0.273926 8.71468 9.17892 -0.165039 20.1547 -0.165039H77.0197C87.9956 -0.165039 96.9006 8.71469 96.9006 19.6774V24.0495C96.9006 35.0123 87.9956 43.892 77.0197 43.892H20.1547C9.17892 43.892 0.273926 35.0123 0.273926 24.0495V19.6774Z"
                fill="#30CAAF"
            />
            <path
                d="M176.322 43.6385C188.01 43.6385 197.485 34.1841 197.485 22.5214C197.485 10.8588 188.01 1.4043 176.322 1.4043C164.634 1.4043 155.16 10.8588 155.16 22.5214C155.16 34.1841 164.634 43.6385 176.322 43.6385Z"
                fill="#6F95F4"
            />
            <path
                d="M178.291 24.5686V31.0235H174.424V24.5686H167.92V20.7098H174.424V14.2549H178.291V20.7098H184.76V24.5686H178.291Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_20401_1342">
                <rect
                    width="217"
                    height="120"
                    fill="white"
                    transform="translate(0.5)"
                />
            </clipPath>
        </defs>
    </svg>
);
